import {
  Box,
  Grid,
  Container,
  Typography,
  Card,
  useTheme,
  useMediaQuery,
} from "../../imports/muiImport";
import { useSelector } from "react-redux";
import { renderHTML } from "../../hooks/utilsFn/utilsFn";
import ImageNotFound from "../../assets/card-image/product-not-found.jpg"
import FoodGiftCardSkeleton from "../../pages/DASHBOARD/FoodGiftCardSkeleton";
import GamingBannerimg from "../../assets/99giftimages/Enter-3.jpeg"
import { useEffect, useState } from "react";
import { getAllProducts } from "../../apiCalls/urlFunction";
import { NavLink, useNavigate } from "react-router-dom";

const EntertainmentGiftCard = () => {
  const FoodgiftCardData = useSelector((state) => state.Dashboard?.Food);
  const categoriesId = useSelector((state) => state?.Dashboard?.categories)
  const [entertainmentAPIData, setentertainmentAPIData] = useState([]);
  const navigate = useNavigate()
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("lg"));
  const isSMUp = useMediaQuery(theme.breakpoints.down("md"));




  const EntertainmentGiftCardAPI = async () => {
    try {
      const payload = {
        "categoryIds[]": "e55c20bb-7e79-42a8-8bd7-d46fc97bd793",
        limit: 10,
      };
      const res = await getAllProducts(payload);
      if (res.status) {
        const senitizeRespose =
          res?.data?.edges?.map((item) => item?.node);

        setentertainmentAPIData(senitizeRespose || []);
      } else {
         setentertainmentAPIData([]);
      }
    } catch (error) {

    }
  }

  useEffect(() => {
    EntertainmentGiftCardAPI();
  }, [])

const productsToShow = isMdUp ? entertainmentAPIData?.slice(0, 6) : isSMUp ? entertainmentAPIData?.slice(0, 3) : entertainmentAPIData?.slice(0, 4);


  const link = (id) => ({
    pathname: `/card-details/${id}`,

  });
  const categorieLink = (id) => ({
    pathname: '/card-list',
    search: `categoryIds[]=${id}`,

  });
  if (!FoodgiftCardData || !FoodgiftCardData.data) {
    return <FoodGiftCardSkeleton />;
  }
 return (
    <Container maxWidth="xl" disableGutters >
      <Grid
        container
        spacing={2}
        alignItems="stretch"
        sx={{
          mb: 5,
          mt: 5,
        }}
      >
        {/* Banner Image Container */}
        <Grid item xs={12} sm={12} md={7}
          sx={{
            display: {
              sm: "none",
              md: "block"
            }
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: {
                xs: 250,
                sm: 300,
                md: 390,
                lg: 400,
              },
              borderRadius: 4,
              overflow: "hidden",
              display: "flex",
            }}
          >
            <Box
              onClick={() => navigate(categorieLink(categoriesId?.[11]?.id))}
              component="img"
              // src={FoodgiftCardData?.image ||ImageNotFound }
              src={GamingBannerimg || ImageNotFound}
              alt="Gaming"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: 4,
                display: "block",
                cursor: "pointer"
              }}
            />
          </Box>
        </Grid>

        {/* Content & Offers Container */}
        <Grid item xs={12} sm={12} md={5}
          sx={{
            position: {
              sm: "relative",
            },
            mb: {
              sm: 20,
              md: "auto"
            },
            display: {
              sm: "flex"
            },
            justifyContent: {
              sm: "flex-start"
            }
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: {
                xs: 250,
                sm: 300,
                md: 390,
                lg: 400,
              },
              backgroundColor: "#F6EEE5",
              borderRadius: 4,
              pt: {
                sm: 1.5
              },
              pb: {
                sm: 4,
              },
              px: {
                sm: 2.5,
              },


              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: {
                  sm: "100%"
                },
                height: {
                  xs: 170,
                  sm: 360,
                  md: 340,
                  lg: 400,
                },
                borderRadius: 4,
                overflow: "hidden",
                display: {
                  sm: "block",
                  md: "none"
                },
                position: 'absolute',
                left: {
                  sm: 10
                },
                top: {
                  sm: 140
                },
                zIndex: 0,
                boxShadow: 6
              }}
            >
              <Box
                onClick={() => navigate(categorieLink(categoriesId?.[5]?.id))}
                component="img"
                // src={FoodgiftCardData?.image ||ImageNotFound }
                src={GamingBannerimg || ImageNotFound}
                alt="Gaming"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 4,
                  display: "block",
                  cursor: "pointer"
                }}
              />
            </Box>

            <Typography
              sx={{
                fontSize: {
                  xs: "none",
                  sm: "2.1rem",
                  md: "22px",
                  lg: "25px",
                },
                fontWeight: 700,
                color: "#000000",
                lineHeight: 1.25,
                fontFamily: "Be Vietnam Pro",

              }}
            >
              Get Entertainment Gift Cards at Lower Prices
            </Typography>

            {/* Sub-text description */}
            <Typography
              sx={{
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "14px",
                },

                mb: 2,
                py: 1,
                color: "#000",
                fontWeight: 400,
                wordSpacing: 1,
                fontFamily: "Be Vietnam Pro",
              }}
            >
              Experience unlimited entertainment with gift cards that give you the freedom to choose. Access movies, music, streaming platforms, and premium content while saving more.
            </Typography>

            {/* Brand Logo Layout Grid */}
            <Box

              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, 1fr)",
                  sm: "repeat(1, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                },
                justifyItems: {
                  sm: "flex-end",
                  md: "center"
                },
                zIndex: 1,

              }}
            >
              {productsToShow?.map((item) => (
                <Card
                  component={NavLink}
                  to={link(item?.id)}
                  key={item.id}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: 165,
                      md: 150,
                      lg: 150

                    },
                    height: {
                      xs: 60,
                      sm: 110,
                      md: 80,
                      lg: 105,
                    },
                    background: "transparent",
                    boxShadow: "none",
                    borderRadius: 4,
                    overflow: "hidden",
                    mb: 1,
                  }}
                >
                  <Box
                    component="img"
                    src={item?.productImages?.[0]?.url || ImageNotFound}
                    alt="Partner Brand"
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: { xs: "none", sm: "contain", md: "cover", lg: "cover" },

                    }}
                  />
                </Card>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EntertainmentGiftCard;
